export default "__VITE_ASSET__Cvkd295h__"